import { Loginpage } from '../containers';

const Login = () => {
  return (
    <div>
        <div className="Login">
          <Loginpage />
        </div>
    </div>
  )
}

export default Login